import {
  SliceCaseReducers,
  SliceSelectors,
  createSlice,
} from '@reduxjs/toolkit';
import { REDUCER_KEYS } from './const';

export interface AlertSliceState {
  showAlert: boolean;
  type: 'error' | 'success' | 'warning' | null;
  message: string;
}

export const alertSlice = createSlice<
  AlertSliceState,
  SliceCaseReducers<AlertSliceState>,
  string,
  SliceSelectors<AlertSliceState>
>({
  name: REDUCER_KEYS.ALERT,
  initialState: {
    showAlert: false,
    type: null,
    message: '',
  },
  reducers: {
    triggerAlert: (
      state,
      payload: { type: string; payload: AlertSliceState }
    ) => ({
      ...state,
      ...payload.payload,
    }),
  },
});
export const { triggerAlert } = alertSlice.actions;

export const alertReducer = alertSlice.reducer;
